import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import {
    AddSelectedProductsUseCase,
    GetAppropriatenessClientUseCase,
    GetMyProductsUseCase,
    GetProductsUseCase,
    ProductInterface,
    ProductSpecification,
    Transaction,
} from '../../../../../core';
import { BasePage } from '../../../base.page';
import { Client, Id, Product } from '../../../../domain/data';
import { ErrorDialog } from '../../../../ui/dialog/error/error.dialog';
import { LocalStorage } from '../../../../client/helpers/local-storage';
import { MainRoutes } from '../../../../main-routes.enum';
import { OperativePage } from '../../operative.page';
import { ParentEvents } from '../../../../utils/parent-events.service';

@Component({
    templateUrl: './operative-product-list.page.html',
    styleUrls: ['./operative-product-list.page.scss'],
})
export class OperativeProductListPage extends BasePage implements AfterViewInit, OnDestroy, OnInit {
    private backSubscription: Subscription;

    public appropriatenessClient: Client;
    public isExpiredDoc = false;
    public isExpiredTest = false;
    public lowProducts: Product[] = [];
    public moderateProducts: Product[] = [];
    public highProducts: Product[] = [];

    constructor(
        operativePage: OperativePage,
        parentEvents: ParentEvents,
        private addSelectedProductsUseCase: AddSelectedProductsUseCase,
        private dialog: MatDialog,
        private getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        private getMyProductsUseCase: GetMyProductsUseCase,
        private getProductsUseCase: GetProductsUseCase,
        private localStorage: LocalStorage,
        private router: Router
    ) {
        super(parentEvents);
        operativePage.showBackButton();
        this.backSubscription = operativePage.back.subscribe(() => {
            this.router.navigateByUrl(MainRoutes.OPERATIVE);
        });
    }

    get canContinue(): boolean {
        let canContinue = false;

        this.lowProducts.map((product) => {
            if (product.selected) {
                canContinue = true;
            }
        });

        if (!canContinue) {
            this.moderateProducts.map((product) => {
                if (product.selected) {
                    canContinue = true;
                }
            });
        }

        if (!canContinue) {
            this.highProducts.map((product) => {
                if (product.selected) {
                    canContinue = true;
                }
            });
        }

        return canContinue;
    }

    get isMyProducts(): boolean {
        return this.router.url.substring(1) === MainRoutes.OPERATIVE_MY_PRODUCTS;
    }

    ngOnInit() {
        this.getAppropriatenessClient();
        this.getProducts();

        this.isExpiredDoc = this.localStorage.isExpiredDoc;
        this.isExpiredTest = this.localStorage.isExpiredTest;
    }

    private getAppropriatenessClient() {
        this.getAppropriatenessClientUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.appropriatenessClient = transaction.data as Client;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    private getProducts() {
        const onNext = (transaction: Transaction<ProductInterface[]>) => {
            if (transaction.isSuccess) {
                transaction.data.map((product) => {
                    if (product.productSpecification === ProductSpecification.MODERATE) {
                        this.moderateProducts.push(product as Product);
                    } else if (product.productSpecification === ProductSpecification.VERY_HIGH) {
                        this.highProducts.push(product as Product);
                    } else {
                        this.lowProducts.push(product as Product);
                    }
                });
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        };

        if (this.router.url.substring(1) === MainRoutes.OPERATIVE_MY_PRODUCTS) {
            this.getMyProductsUseCase.bind().subscribe(onNext);
        } else {
            this.getProductsUseCase.bind().subscribe(onNext);
        }
    }

    ngOnDestroy() {
        this.backSubscription.unsubscribe();
    }

    onAddMyProducts() {
        this.router.navigateByUrl(MainRoutes.OPERATIVE_MY_PRODUCTS);
    }

    onAddProducts() {
        this.router.navigateByUrl(MainRoutes.OPERATIVE_PRODUCTS);
    }

    onAccordionChange() {
        this.parentEvents.resize();
    }

    onDetail(code: Id) {
        this.localStorage.step = 99;
        this.localStorage.write();

        window.open(MainRoutes.OPERATIVE_PRODUCTS_DETAIL.replace(':id', encodeURIComponent(String(code))), '_blank');
    }

    onClick() {
        let products: Product[] = [];
        products = products.concat(this.lowProducts.filter((product) => product.selected));
        products = products.concat(this.moderateProducts.filter((product) => product.selected));
        products = products.concat(this.highProducts.filter((product) => product.selected));

        this.addSelectedProductsUseCase
            .bind({
                products,
                check: false,
                clientCode: Id.fromString(this.localStorage.clientCode),
            })
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.router.navigateByUrl(MainRoutes.OPERATIVE);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
    }
}
